import { Theme } from "@mui/material";

import { cssPropertiesToString } from "./cssPropertiesToString";

export const cssForHeaderWithLinearGradient = (
  theme: Theme,
  backgroundImage?: string,
) => {
  return cssPropertiesToString({
    backgroundImage: backgroundImage ?? theme.headerLinearGradient,
    color: "transparent",
    backgroundClip: "text",
    paddingRight: "2px",
  });
};
